import { MutableRefObject } from "react";

import { useAppBarHeight } from "./useAppBarHeight";
import { useProductPageHeaderHeight } from "./useProductPageHeaderHeight";

export const useProductPageScrollMarginTop = (
    headerRef: MutableRefObject<HTMLDivElement | null>,
    withStickyAppBar: boolean,
    scrollableContainerRef?: MutableRefObject<HTMLDivElement | null>
) => {
    const { withStickyHeader, headerHeight } = useProductPageHeaderHeight(headerRef, scrollableContainerRef);
    const appBarHeight = useAppBarHeight();
    const appBarOffset = withStickyAppBar ? appBarHeight : 0;
    return withStickyHeader ? headerHeight + appBarOffset : appBarOffset;
};
